













































import { Component, Vue } from 'vue-property-decorator';
import constants from '@/utils/constants';
import { firebaseDB } from '@/firebase';

@Component
export default class UpdateVersion extends Vue {
  public pageTitle: string = 'Update Version';
  public $swal: any;
  public loading: boolean = false;
  public currentVersion: number = Number(process.env.VUE_APP_VERSION);
  public version: number | null = null;
  public isUpdating = false;
  public constants: any = constants;

  get disableUpdate() {
    return (
      !this.currentVersion ||
      this.loading ||
      this.isUpdating ||
      this.currentVersion === this.version
    );
  }

  mounted() {
    this.getVersion();
  }

  getVersion() {
    this.loading = true;
    const doc = firebaseDB.collection('Version').doc('BO');
    doc.get().then(snapshot => {
      this.loading = false;
      if (snapshot.exists && snapshot.get('version')) {
        this.version = snapshot.get('version');
      }
    })
  }

  updateVersion() {
    this.$swal('Do you want to sync current version to firebase?', {
      icon: constants.STATUS_WARNING,
      buttons: true,
      dangerMode: true
    }).then(value => {
      if (value) {
        this.isUpdating = true;
        const doc = firebaseDB.collection('Version').doc('BO');
        doc.get().then(snapshot => {
          if (snapshot.exists) {
            doc.set({
              version: this.currentVersion
            }).then(() => {
              this.isUpdating = false;
              this.getVersion();
            });
          } else {
            this.isUpdating = false;
            this.$swal(constants.SOMETHING_WROING, '', constants.STATUS_ERROR)
          }
        })
      }
    });
  }
}
